import React from 'react'
import PlanContainer from '../../../../../features/signup/components/PlanContainer/PlanContainer'
import CCModal2025 from '../../../../../components/ccModal2025'
import { BILLING_PLAN_TYPE } from '../../../../../features/signup/constantStep'
import { I18n } from 'react-redux-i18n'
// import './choosePlanPopup.scss'

const ChoosePlanPopup = ({
	currentBillingPlan,
	onClose,
	onSubmit,
	pricingConfigs,
	billingUsage,
}) => {
	const compareFeeBetweenPlan = (billingType, plan1, plan2) => {
		const fee1 = plan1?.pricingConfigs?.find(p => p.type === billingType)?.fee || 0
		const fee2 = plan2?.pricingConfigs?.find(p => p.type === billingType)?.fee || 0
		if(fee1 > fee2) return true
		return false
	}
	const customPlanBasedCurrentBillingPlan = () => {
		if(!pricingConfigs || pricingConfigs.length === 0) {
			return []
		}
		const currentPlan = pricingConfigs.find(p => p._id === currentBillingPlan.planId) || {}
		return pricingConfigs.map((plan, index) => {
			if(plan._id === currentPlan._id) {
				plan.buttonText = I18n.t('billingUsage.currentPlanButton')
			} else {
				if(compareFeeBetweenPlan(currentBillingPlan.billingType, plan, currentPlan)) {
					plan.buttonText = I18n.t('billingUsage.upgrade')
				} else {
					plan.buttonText = ''
					plan.disabledAll = true
				}
			}
			return plan
		})
	}

	const handleSubmit = (planId, billingType) => {
		const billingPlan = pricingConfigs?.find(p => p._id === planId)
		if(billingPlan) {
			onSubmit(billingPlan, billingType)
		}
	}
	return (
		<CCModal2025
			hideFooter={true}
			isShow={true}
			onClose={onClose}
			size="xl"
			className="choose-plan-popup"
			dialogClassName={`size-dialog-${customPlanBasedCurrentBillingPlan().length}`}
		>
			<div className="fleet-onboarding">
				<PlanContainer
					pricingConfigs={customPlanBasedCurrentBillingPlan()}
					onSubmit={handleSubmit}
					billingPlanFleetSelected={currentBillingPlan}
					disabledSwitchBtn={billingUsage?.billingType === BILLING_PLAN_TYPE.annual}
				/>
			</div>
		</CCModal2025>
	)
}

export default ChoosePlanPopup